import CustomHTTPService from './custom-http.service';
import EncodeDecodeType from '../enums/EncodeDecodeType';

export default class OnlineApiService {

   static checkUser(mobileNo) {
        const url =
            "https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/customer/authapp/v1/checkuser";
        const config = {
            headers: {
                googleCookie: "airtel.com",
            }
        };
        const data = {
            userid: mobileNo
        };
        return CustomHTTPService.post(url, data, config, EncodeDecodeType.ONLINE);
    }

    static generateOtp(requestKey) {
        const url =
            "https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/customer/authapp/v1/generateotp";
        const config = {
            headers: {
                googleCookie: "airtel.com",
            },
        };
        const data = { requestkey: requestKey };
        return CustomHTTPService.post(url, data, config, EncodeDecodeType.ONLINE);
    }

    static validateOtp(requestKey, Otp) {
        const url =
            "https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/customer/authapp/v1/validateuserwithotp";
        const config = {
            headers: {
                googleCookie: "airtel.com",
            }
        };
        const data = { requestkey: requestKey, otp: Otp };
        return CustomHTTPService.post(url, data, config, EncodeDecodeType.ONLINE);
    }

    static authLogin(requestKey) {
        const url = `https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/customer/authapp/v1/authloginget?requestkey=${requestKey}`;
        const config = {
            headers: {
                googleCookie: "airtel.com",
            }
        };
        return CustomHTTPService.get(url, config, EncodeDecodeType.ONLINE);
    }

    static isUserLoggedIn() {
        const url =
            "https://www.airtel.in/s/app/wl-service/airtel-digital-profile/rest/customer/profile/unauth/v1/get/login/info";
        const config = {
            headers: {
                googleCookie: "google.com",
                adsHeader: "adsHeader",
                ignoreError: true,
                ignoreMobileApp: true
            }
        };
        return CustomHTTPService.get(url, config, EncodeDecodeType.DEFAULT);
    };
}


// WEBPACK FOOTER //
// ./src/services/online-api.service.js